import { useEffect, useState } from 'react';
import { filter, includes, isNull, isUndefined, keys, map, pickBy, some } from 'lodash';
import useLoggedUser from '../useLoggedUser';
import { columnsCategories } from './columnsCategories';
import { IDefaultPatientColumns } from '../../Pages/store';
import useCurrentClinic from '../useCurrentClinic';

const kinomaticDefaultColumns = {
  name: true,
  country: true,
  therapistUuid: true,
  joinDate: true,
  meeting: true,
  current_course: false,
  activeDays: false,
  ptTime: false,
  fallRisk: true,
  status: true,
  sts: false,
  tug: false,
  fes: false,
  alerts: false,
};
export const defaultColumns = {
  name: true,
  country: false,
  therapistUuid: true,
  joinDate: true,
  meeting: true,
  current_course: false,
  activeDays: true,
  ptTime: true,
  fallRisk: true,
  status: true,
  sts: false,
  tug: false,
  fes: false,
  alerts: false,
};

export function useVisibleColumns() {
  const { myProfile } = useLoggedUser();
  const { clinic, isKinomatic } = useCurrentClinic();
  const clinicUuid = clinic?.uuid;
  const key = `${clinicUuid}_clinicVisibleColumns`;

  const defaultPatientColumns = (isKinomatic
    ? kinomaticDefaultColumns
    : clinic?.webClientConfig?.defaultPatientColumns || defaultColumns) as IDefaultPatientColumns;

  const [visibleColumns, setVisibleColumns] = useState<{[key: string] : boolean}>({});

  const getVisibleColumns = () => {
    if (!clinicUuid) return {};

    const savedVisibleColumns = localStorage[key];
    if (savedVisibleColumns) {
      return JSON.parse(localStorage[key]);
    }

    return defaultPatientColumns;
  }

  useEffect(() => {
    setVisibleColumns(getVisibleColumns())
  }, [clinicUuid]);

  const resetColumns = () => {
    localStorage.removeItem(key);
    setVisibleColumns(getVisibleColumns())
  }
  const toggleVisibleColumn = (uuid: string, visible: boolean) => {
    localStorage.setItem(key, JSON.stringify({
      ...visibleColumns,
      [uuid]: visible,
    }));

    const visible_columns = getVisibleColumns();
    setVisibleColumns(visible_columns);

    return visible_columns;
  };
  const getResourcesQueryParam = () => {
    const visibleColumnsKeys = keys(visibleColumns).filter((key) => {
      return visibleColumns[key];
    });
    const visibilityResources = filter(columnsCategories, (category) => {
      return (
        (category?.columnsIds &&
          some(category.columnsIds, (x) => includes(visibleColumnsKeys, x))) ||
        (category.queryByDefault ?? false)
      );
    });

    return [
      ...map(pickBy(visibilityResources, 'resource'), 'resource'),
      myProfile?.countRtmTime ? columnsCategories.therapistTime.resource : null,
    ].filter((x) => !isUndefined(x) && !isNull(x)) as string[];
  };

  return {
    visibleColumns,
    toggleVisibleColumn,
    defaultPatientColumns,
    resetColumns,
    getResourcesQueryParam,
  };
}
